/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignBottomFilled = createReactComponent("filled", "layout-align-bottom-filled", "IconLayoutAlignBottomFilled", [["path", { "d": "M20 19a1 1 0 0 1 0 2h-16a1 1 0 0 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M13 3a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

export { IconLayoutAlignBottomFilled as default };
//# sourceMappingURL=IconLayoutAlignBottomFilled.mjs.map
